import WebsiteModel        from '@models/website/WebsiteModel';
import SitePageStatusModel from '@models/website/SitePageStatusModel';
import doc                 from '@widesk-core/decorators/doc';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import Blamable            from '@/models/traits/Blamable';
import { Addable }         from '@widesk-core/decorators/addable';
import { Editable }        from '@widesk-core/decorators/editable';
import { Deletable }       from '@widesk-core/decorators/deletable';
import { Timestampable }   from '@widesk-core/decorators/timestampable';

@doc.path('/site_pages/{?id}')
@doc.addable
@doc.editable
@doc.deletable
@doc.timestampable
abstract class AbstractSitePageModel extends Blamable(WebsiteServiceModel) {
	declare protected _tsFilters: {
		'partial': string;
		'private': string;
		'codeProtected': string;
		'existsInContentToPublish': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'reference': Website_SitePageReference;
		'sitePageStatus': string;
		'sitePageTags.tag': id;
		'slug': id;
		'website': id;
		'sitePageUserGroups.userGroup': id;
		'search': string;
	};

	declare private _tsSorts: {
		'id': string;
		'slug': string;
		'private': string;
		'createdAt': string;
		'updatedAt': string;
		'translations.title': string;
	};

	@doc.model(WebsiteModel) declare website: WebsiteModel;
	@doc.string declare slug: string;
	@doc.string declare reference: Website_SitePageReference;
	@doc.model(SitePageStatusModel) declare sitePageStatus: SitePageStatusModel;
	@doc.boolean declare private: boolean;
	@doc.boolean declare codeProtected: boolean;
}

interface AbstractSitePageModel
	extends Addable,
		Editable,
		Deletable,
		Timestampable {}

export default AbstractSitePageModel;
